module.exports = __webpack_public_path__ + "static/media/bg.9e08e99b.svg";